const productCategoryIds = (product) => {
  if (Array.isArray(product?.categories) && product.categories.length > 0) {
    return product.categories
      .map((entry) => Number(entry?.categoryId ?? entry?.category?.id))
      .filter((id) => Number.isInteger(id) && id > 0);
  }
  const categoryId = Number(product?.categoryId);
  return Number.isInteger(categoryId) && categoryId > 0 ? [categoryId] : [];
};

export const applyUserCategoryVisibility = (categories, products, settings) => {
  const categoryList = Array.isArray(categories) ? categories : [];
  const productList = Array.isArray(products) ? products : [];
  if (!settings?.configured) return { categories: categoryList, products: productList };

  const visibleIds = new Set(
    (Array.isArray(settings.visibleCategoryIds) ? settings.visibleCategoryIds : [])
      .map(Number)
      .filter((id) => Number.isInteger(id) && id > 0)
  );

  return {
    categories: categoryList.filter((category) => visibleIds.has(Number(category.id))),
    products: productList.filter((product) => {
      const categoryIds = productCategoryIds(product);
      return categoryIds.length === 0 || categoryIds.some((id) => visibleIds.has(id));
    }),
  };
};
